import React from 'react';
import Grid from '@material-ui/core/Grid';
import strings from 'strings';
import { FPActionButton } from 'UI/components/atoms';
import { SvgMakeAi } from 'UI/res';

import { useBulkAIButtonStyles } from './BulkAIButton.styled';

const { actions: actionsCopies } = strings.ai.generators;

export const BulkAIButton = ({ shouldEnable, onOpenAiDrawer }) => {
  const classes = useBulkAIButtonStyles();

  return (
    <Grid container item justifyContent="flex-end" className={classes.buttonContainer}>
      <FPActionButton
        text={actionsCopies.generateWithAI}
        icon={SvgMakeAi}
        disabled={!shouldEnable}
        iconPosition="right"
        onClick={onOpenAiDrawer}
        withGradient
      />
    </Grid>
  );
};
